/**
 * @flow
 * Created by neo on 01.06.17.
 */

import {observable} from 'mobx';

export default class Passenger {
  @observable first_name: string;
  @observable last_name: string;
  @observable weight: number;

  constructor(json?: any) {
    if(json) {
      this.first_name = json.first_name;
      this.last_name = json.last_name;
      this.weight = json.weight;
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Booking/Passenger.js